<template>
  <div v-if="isLoaded">
    <div v-if="isPrint && leads.length">
      <PrintVersion v-for="lead of leads" :key="`print_${lead.id}`" :lead="lead" />
    </div>
    <div v-else-if="leads.length">
      <AppHeader/>
      <div class="card">
        <GeneralContainer/>
        <ObjectMap/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GeneralContainer from './GeneralContainer/GeneralContainer.vue'
import AppHeader from './AppHeader'
import ObjectMap from './ObjectMap.vue'
import PrintVersion from './PrintVersion.vue'

export default {
  name: 'App',
  components: {
    GeneralContainer,
    ObjectMap,
    PrintVersion,
    AppHeader,
  },
  async mounted() {
    try {
      const configString = document.querySelector('#ww-data').getAttribute('data-config')
      const config = JSON.parse(configString)
      if (config) {
        this.setGlobalConfig(config)
        await this.setPresentations()
      }
      this.isLoaded = true

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = '/rc/js/common.js?ver=1.4'
      document.head.appendChild(script)

      if (!this.logoHost) return

      document.querySelector('[rel = "icon"]').setAttribute('href', this.logoHost)
    } catch (e) {
      console.debug()
    }

    Promise.all([
      this.getHidingFieldsConfig(),
      this.getUploadsConfig(),
    ])
  },
  computed: {
    ...mapGetters(['leads', 'logoHost', 'isPrint']),
  },
  methods: {
    ...mapActions([
      'setGlobalConfig',
      'getHidingFieldsConfig',
      'getUploadsConfig',
      'setPresentations',
    ]),
  },
  data() {
    return {
      isLoaded: false,
    }
  },
}
</script>

<style scoped>
@import url('../assets/css/bootstrap/bootstrap-grid.css');
@import url('../assets/css/slick-1.5.9/slick.css');
@import url('../assets/css/slick-1.5.9/slick-theme.css');
@import '../assets/css/fonts.css?ver=1.2';
@import '../assets/css/main.css?ver=1.8';
@import '../assets/css/media.css?ver=1.8';

.card {
  padding-bottom: 0 !important;
}
</style>

<style>
@media print {
  .ww-pagebreak {
    page-break-after: always;
  }
}
</style>
